import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { removeUser } from "../utils/userSlice";
import useRequireAuth from "../utils/useRequireAuth";
import { Avatar } from "@mui/material";
import { deepPurple } from "@mui/material/colors";
import { getInitials } from "../utils/utilityFunctions/stringUtility";
import useClickOutside from "../hooks/Screen/useClickOutside";
import { ReactComponent as HeaderNotifyImg } from "../assets/images/headerNotifyImg.svg";
import { ReactComponent as ViewAllOtherNotis } from "../assets/images/viewAllOtheNotis.svg";
import { ReactComponent as DownAngleBracket } from "../assets/images/downAngleBracket.svg";
import { ReactComponent as SidebarImg } from "../assets/images/sidebarImg.svg";
import { ReactComponent as PrivacyIcon } from "../assets/images/icons/PrivacyIcon.svg";
import { ReactComponent as SettingIcon } from "../assets/images/icons/SettingIcon.svg";
import { ReactComponent as LogoutIcon } from "../assets/images/icons/LogoutIcon.svg";
import { ReactComponent as ProfileIcon } from "../assets/images/icons/ProfileIcon.svg";

import SettingBIcon from "../assets/images/icons/SettingBgIcon";
import LogoutBgIcon from "../assets/images/icons/LogoutBgIcon";
import ConfirmationDialog from "./UniversalComponents/ConfirmationDialogMulti";
import AvatarName from "./UniversalComponents/AvatarName";

const Header = () => {
  const user = useRequireAuth();
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useRequireAuth();
  const storedData = localStorage.getItem("company_data");
  const companyId = storedData ? JSON.parse(storedData) : null;
  const [isHovered, setIsHovered] = useState(false);

  const myUserDataString = localStorage.getItem("myUserData");
  const myUserData = JSON.parse(myUserDataString);
  const [userName, setUserName] = useState();
  const [isSettingdropdownOpen, setIsSettingDropdownOpen] = useState(false);
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  let userToken = token || JSON.parse(localStorage.getItem("myUserData")).token;
  const SettingtoggleDropdown = () => {
    if (profileDropdownOpen) {
      setProfileDropdownOpen(false);
    }
    setIsSettingDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    if (!isSettingdropdownOpen) setIsHovered(false);
  }, [isSettingdropdownOpen]);

  const ProfiletoggleDropdown = () => {
    if (isSettingdropdownOpen) {
      setIsSettingDropdownOpen(false);
    }
    setProfileDropdownOpen((prev) => !prev);
  };
  const closeSettingoutSideClick = useClickOutside(() => {
    setIsSettingDropdownOpen(false);
  });
  const closeProfileoutSideClick = useClickOutside(() => {
    setProfileDropdownOpen(false);
  });

  const handleDeleteConfirmation = () => {
    setShowConfirmation(true);
  };

  const handleSignOut = async () => {
    const Authtoken = user.token;

    try {
      // Dont deleted commented below (below code is for server side validation)

      // const response = await fetch(LOGOUT_URL, {
      //   method: "POST",
      //   headers: {
      //     Authorization: `Bearer ${Authtoken}`,
      //   },
      // });

      // if (!response.ok) {
      //   throw new Error("Logout failed");
      // }
      dispatch(removeUser(null));
      Navigate("/");
    } catch (error) {
      console.error("Logout failed:", error.message);
    }
  };

  // const initialName = user?.name;
  // const name = initialName ? initialName.split(" ")[0].charAt(0).toUpperCase() : "";
  // useEffect(() => {
  //   setUserName(initialName);
  // }, [initialName]);
  const initialName = user?.name;
  const nameInitials = initialName
    ? initialName
        .split(" ") // Split the full name into an array
        .filter((word) => word.length > 0) // Remove any empty spaces
        .slice(0, 2) // Take only the first two words (first and last name)
        .map((word) => word.charAt(0).toUpperCase()) // Extract first letter and capitalize
        .join("") // Join letters together
    : "";
  return (
    <nav className="z-[1200] w-full bg-white py-1">
      <div className="px-3 py-1 lg:px-5 lg:pl-3 ">
        <div className="flex items-center justify-between">
          <div className="text-1D5D9B text-20 font-500">{myUserData?.organization_name}</div>
          <div className="flex items-center justify-start rtl:justify-end">
            <button
              data-drawer-target="logo-sidebar"
              data-drawer-toggle="logo-sidebar"
              aria-controls="logo-sidebar"
              type="button"
              className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            >
              <span className="sr-only">Open sidebar</span>
              {/* <svg
                className="w-6 h-6"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clipRule="evenodd"
                  fillRule="evenodd"
                  d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                ></path>
              </svg> */}
              <SidebarImg className="w-6 h-6" />
            </button>
          </div>

          <div className="flex items-center">
            <div className="flex items-center ms-3">
              {isSettingdropdownOpen && (
                <div className="top-14 absolute bg-white border right-4 p-5 shadow-3 rounded-lg h-[446px] w-[900px]">
                  <div className="flex justify-around" ref={closeSettingoutSideClick}>
                    <div className="group">
                      <h3 className="mb-5 text-203C50 text-16 font-500 border-b-2 border-white group-hover:border-b-2 group-hover:border-203C50">
                        Settings
                      </h3>
                      <div>
                        <ul className="space-y-4 text-778FA5 text-14 font-400 capitalize">
                          <li className="hover:text-black cursor-pointer">Company Settings</li>
                          <li className="hover:text-black cursor-pointer">Chart Of Accounts</li>
                          <li className="hover:text-black cursor-pointer">Payroll Settings</li>
                          <li className="hover:text-black cursor-pointer">Workers Comp</li>
                          <li className="hover:text-black cursor-pointer">HR Advisor</li>
                          <li className="hover:text-black cursor-pointer">Employee Benefits</li>
                          <li className="hover:text-black cursor-pointer">Get the desktop App</li>
                          <li className="hover:text-black cursor-pointer">Additional Info</li>
                          <li className="hover:text-black cursor-pointer">Priority Circle</li>
                        </ul>
                      </div>
                    </div>
                    <div className="group">
                      <h3 className="mb-5 text-203C50 text-16 font-500 border-b-2 border-white group-hover:border-b-2 group-hover:border-203C50">
                        Lists
                      </h3>
                      <div>
                        <ul className="space-y-4 text-778FA5 text-14 font-400 capitalize ">
                          <li className="hover:text-black cursor-pointer">All List</li>
                          <li className="hover:text-black cursor-pointer">Products & Services</li>
                          <li className="hover:text-black cursor-pointer">recurring Transactions</li>
                          <li className="hover:text-black cursor-pointer">Attachment</li>
                          <li className="hover:text-black cursor-pointer">Custom Field</li>
                          <li className="hover:text-black cursor-pointer">tags</li>
                          <li className="hover:text-black cursor-pointer">Rules</li>
                        </ul>
                      </div>
                    </div>
                    <div className="group">
                      <h3 className="mb-5 text-203C50 text-16 font-500 border-b-2 border-white group-hover:border-b-2 group-hover:border-203C50">
                        Tools
                      </h3>
                      <div>
                        <ul className="space-y-4 text-778FA5 text-14 font-400 capitalize ">
                          <li className="hover:text-black cursor-pointer">Manage Workflow</li>
                          <li className="hover:text-black cursor-pointer">Order Checks</li>
                          <li className="hover:text-black cursor-pointer">Import Data</li>
                          <li className="hover:text-black cursor-pointer">Import Desktop Data</li>
                          <li className="hover:text-black cursor-pointer">Reconcile</li>
                          <li className="hover:text-black cursor-pointer">Budgeting</li>
                          <li className="hover:text-black cursor-pointer">Spreadsheet Sync</li>
                          <li className="hover:text-black cursor-pointer">Audit Log</li>
                          <li className="hover:text-black cursor-pointer">Smart Look</li>
                          <li className="hover:text-black cursor-pointer">Resolution Center</li>
                        </ul>
                      </div>
                    </div>
                    <div className="group">
                      <h3 className="mb-5 text-203C50 text-16 font-500  border-b-2 border-white group-hover:border-b-2 group-hover:border-203C50">
                        Your Company
                      </h3>
                      <div>
                        <ul className="space-y-4 text-778FA5 text-14 font-400 capitalize ">
                          <li className="hover:text-black cursor-pointer">Subscription & Billing</li>
                          <li className="hover:text-black cursor-pointer">Getting Started</li>
                          <li className="hover:text-black cursor-pointer">Sample Company</li>
                          <li className="hover:text-black cursor-pointer">Feedback</li>

                          <li
                            className="hover:text-black cursor-pointer"
                            // onClick={handelCompanyDelegation}
                          >
                            Manage Access
                          </li>
                          <li
                            className="hover:text-black cursor-pointer"
                            //onClick={handelManagePermission}
                          >
                            Manage Group
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="p-1 px-3 border-e-2 cursor-pointer">
                {user && (
                  <span className="group" onClick={handleSignOut}>
                    <LogoutBgIcon />
                  </span>
                )}
              </div>

              {/* below  setting dropdown is commmented do not delete it  */}

              {/* <div className="p-1 px-3 border-e-2 group cursor-pointer " onClick={SettingtoggleDropdown}>
                <SettingBIcon isActive={isSettingdropdownOpen} />
              </div> */}
              <div
              // className="p-1 px-3 border-e-2"
              >
                {/* <button
                  id="dropdownNotificationButton"
                  data-dropdown-toggle="dropdownNotification"
                  className="relative inline-flex items-center text-sm font-medium text-center text-gray-500 "
                  type="button"
                >
                  <i className="bi bi-bell text-lg"></i>
                  <div className="absolute block w-3 h-3 bg-red-500 border-2 border-white rounded-full -top-0.5 start-2.5 dark:border-gray-900"></div>
                </button> */}
                <div
                  id="dropdownNotification"
                  className="z-20 hidden w-full max-w-sm bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-800 dark:divide-gray-700"
                  aria-labelledby="dropdownNotificationButton"
                >
                  <div className="block px-4 py-2 font-medium text-center text-gray-700 rounded-t-lg bg-gray-50 dark:bg-gray-800 dark:text-white">
                    Notifications
                  </div>
                  <div className="divide-y divide-gray-100 dark:divide-gray-700">
                    <a href="#" className="flex px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700">
                      <div className="flex-shrink-0">
                        <div className="absolute flex items-center justify-center w-5 h-5 ms-6 -mt-5 bg-blue-600 border border-white rounded-full dark:border-gray-800">
                          {/* <svg
                            className="w-2 h-2 text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 18 18"
                          >
                            <path d="M1 18h16a1 1 0 0 0 1-1v-6h-4.439a.99.99 0 0 0-.908.6 3.978 3.978 0 0 1-7.306 0 .99.99 0 0 0-.908-.6H0v6a1 1 0 0 0 1 1Z" />
                            <path d="M4.439 9a2.99 2.99 0 0 1 2.742 1.8 1.977 1.977 0 0 0 3.638 0A2.99 2.99 0 0 1 13.561 9H17.8L15.977.783A1 1 0 0 0 15 0H3a1 1 0 0 0-.977.783L.2 9h4.239Z" />
                          </svg> */}
                          <HeaderNotifyImg />
                        </div>
                      </div>
                      <div className="w-full ps-3">
                        <div className="text-gray-500 text-sm mb-1.5 dark:text-gray-400">
                          New message from{" "}
                          <span className="font-semibold text-gray-900 dark:text-white">Jese Leos</span>: "Hey, what's
                          up? All set for the presentation?"
                        </div>
                        <div className="text-xs text-blue-600 dark:text-blue-500">a few moments ago</div>
                      </div>
                    </a>
                    {/* Other notifications */}
                    <div className="p-1 px-3 border-e-2">
                      <i className="bi bi-question-circle text-lg"></i>
                    </div>
                  </div>
                  <a
                    href="#"
                    className="block py-2 text-sm font-medium text-center text-gray-900 rounded-b-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-white"
                  >
                    <div className="inline-flex items-center ">
                      {/* <svg
                        className="w-4 h-4 me-2 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 14"
                      >
                        <path d="M10 0C4.612 0 0 5.336 0 7c0 1.742 3.546 7 10 7 6.454 0 10-5.258 10-7 0-1.664-4.612-7-10-7Zm0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" />
                      </svg> */}
                      <ViewAllOtherNotis />
                      View all
                    </div>
                  </a>
                </div>
              </div>

              {/* <div className="p-1 px-3 border-e-2">
                <i className="bi bi-question-circle text-lg"></i>
              </div> */}

              <div className="flex items-center" ref={closeProfileoutSideClick}>
                <div>
                  <button
                    id="dropdownAvatarNameButton"
                    data-dropdown-toggle="dropdown-user"
                    className="capitalize flex items-center text-sm pe-1 font-medium text-1D4469 hover:text-cyan-500 md:me-0"
                    type="button"
                    fdprocessedid="7lar5b"
                    onClick={ProfiletoggleDropdown}
                  >
                    <span className="sr-only">Open user menu</span>
                    <span className="flex items-center flex-row gap-2 pl-3 pr-2">
                      <AvatarName
                        name={nameInitials}
                        size="medium"
                        bgColor={"#e8ecf299"}
                        textColor={"#7C7C83"}
                        borderColor={"#ABABAC"}
                      />
                      <span className="authname"> {user?.name}</span>
                      <DownAngleBracket className="w-2.5 h-2.5 ms-3" />
                    </span>
                  </button>
                </div>
                {profileDropdownOpen && (
                  <div>
                    <div className="bg-white absolute mt-5 border rounded-lg shadow w-60 right-6">
                      <div className="p-3">
                        <ul className="ml-0 space-y-2">
                          <li
                            className="text-778FA5 p-2 bg-1D4469 rounded font-medium text-14"
                            // onClick={handleProfileClick}
                          >
                            <div className="flex">
                              <div className="mr-5">
                                <AvatarName
                                  name={getInitials(user?.name)}
                                  size="medium"
                                  bgColor={"#673ab7"}
                                  textColor={"#ffffff"}
                                  // borderColor={"#ffffff"}
                                />
                              </div>
                              <div className="flex items-center">
                                <p className="capitalize text-white text-14 font-500">{user?.name}</p>
                                {/* <p>
                                  <span className="text-12 text-ffffffb3 font-500">
                                    User Id:
                                  </span>
                                  <span className="text-12 font-500 text-ffffffb3">
                                    {user?.id}
                                  </span>
                                </p> */}
                              </div>
                            </div>
                          </li>
                          {/* Thse two tabs are temporarily disable it will uncommented in future  */}

                          {/* <li className="text-778FA5 flex hover:text-1D4469 group hover:bg-[#F3F5F7] items-center gap-5 p-2 bg-white hover:bg-F3F5F7  rounded font-400 hover:font-400 text-14 hover:border-l-2 hover:border-1D4469 border-l-2 border-white">
                            <ProfileIcon className=" fill-[#969BA9] group-hover:fill-[#1D4469]" />
                            My Account
                          </li>
                          <li className="text-778FA5 hover:text-1D4469 p-2 bg-white flex group gap-5 hover:bg-[#F3F5F7] items-center rounded font-400 hover:font-400 text-14 hover:border-l-2 hover:border-1D4469 border-l-2 border-white">
                            <PrivacyIcon className=" fill-[#969BA9] group-hover:fill-[#1D4469]" />
                            Privacy
                          </li> */}

                          {false && (
                            <li
                              onClick={SettingtoggleDropdown}
                              className="text-778FA5 hover:text-1D4469 p-2 bg-white hover:bg-[#F3F5F7] group flex gap-5 rounded items-center font-400 hover:font-400 text-14 hover:border-l-2 hover:border-1D4469 border-l-2 border-white"
                            >
                              <SettingIcon className=" fill-[#969BA9] group-hover:fill-[#1D4469]" />
                              Setting
                            </li>
                          )}
                          <li
                            onClick={handleDeleteConfirmation}
                            className="text-778FA5 hover:text-1D4469 p-2 bg-white hover:bg-[#F3F5F7] ml-1 group flex gap-5 rounded items-center font-400 hover:font-400 text-14 hover:border-l-2 hover:border-1D4469 border-l-2 border-white"
                          >
                            <LogoutIcon className=" fill-[#969BA9] group-hover:fill-[#1D4469]" />
                            Logout
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {showConfirmation && (
                <ConfirmationDialog
                  open={showConfirmation}
                  onConfirm={handleSignOut}
                  onClose={() => setShowConfirmation(false)}
                  title="Logout Account?"
                  message={`Are you sure want to logout from this account ?`}
                  confirmVariant="delete"
                  iconVariant="logout"
                  // cancelVariant="action"
                  cancelText="No"
                  // variant="delete"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
